import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";

// img
import u1 from "../../../Assets/images/authbg.png";
import { Link, useNavigate } from "react-router-dom";
import { CstmPagination } from "../../../components/Common/Common";
import { GET_REPORTED_USERS, HELP_LIST, REPORTLIST } from "../../../services/ApiCalls";
import Filter from "../../../components/Common/Filter";
import {
  activeInActiveArr,
  activeInactiveOptions,
} from "../../../utilities/const";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import { exportCsvHandler } from "../../../utilities/utilities";
import moment from "moment";
import TableActions from "../../../components/Common/TableActions";

const Reported = () => {
  const [exportLoader, setExportLoader] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
  const [showModal, setShowModal] = useState(false);
  
  const openModal = (item) => {
    setSelectedReport(item);
    setShowModal(true);
  };

  const navigate = useNavigate();
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: GET_REPORTED_USERS,
  });
  const filterOptions = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Open",
      value: "open",
    },
    {
      label: "Closed",
      value: "closed",
    },
    {
      label: "Cancelled",
      value: "cancelled",
    },

  ];

    const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    // { head: "Order ID", accessor: "customOrderId" },

    {
      head: "Reported By",
      accessor: "name",
      component: (item, key) => {
        return <>{item.reportBy?.fname +" "+ item.reportBy?.lname}</>;
      },
    },
    {
      head: "Reported To",
      accessor: "name",
      component: (item, key) => {
        return <>{item.reportTo?.fname +" "+ item.reportTo?.lname}</>;
      },
    },
    {
      head: "Title",
      accessor: "name",
      component: (item, key) => {
        return <>{item?.noticeId?.title||"-"}</>;
      },
    },
    // {
    //   head: "Service",
    //   accessor: "serviceType",
    //   component: (item, key) => {
    //     return <>{item.serviceTypeDetails?.catName}</>;
    //   },
    // },

    // {
    //   head: "Amount",
    //   component: (item, key) => {
    //     return <>${item.orderTotal}</>;
    //   },
    // },
  ];

//   if (body?.orderStatus === "completed") {
//     column.push({
//       head: "Duration",
//       accessor: "duration",
//       component: (item, key, arr) => <>{item?.duration || 1} hour</>,
//     });
//   }

  column.push(
    {
      head: "Reported Date",
      accessor: "Scheduled",
      component: (item, key, arr) => (
        <>{moment(item.date_created_utc).format("DD-MM-YYYY")}</>
      ),
    },
    // {
    //   head: "Slot",
    //   accessor: "slot",
    //   component: (item, key, arr) => (
    //     <>{moment(item.date_created_utc).format("HH:MM")}</>
    //   ),
    // },
    // {
    //   head: "Payment Mode",
    //   accessor: "paymentMethod",
    //   component: (item, key, arr) => <>{item.paymentMethod}</>,
    // },
    // {
    //   head: "Payment Status",
    //   accessor: "paymentStatus",
    //   component: (item, key, arr) => <>{item.paymentStatus}</>,
    // },
    // {
    //   head: "User Review",
    //   accessor: "reviewCount",
    //   component: (item, key, arr) => <>{item.reviewCount}</>,
    // },
    // {
    //   head: "Status",
    //   accessor: "orderStatus",
    //   component: (item, key, arr) => (
    //     <p
    //       className={`status   ${
    //         pendingTabStatusArr?.includes(item.orderStatus)
    //           ? "yellowLabel"
    //           : ongoingTabStatusArr?.includes(item.orderStatus)
    //           ? "yellowLabel"
    //           : item.orderStatus == "completed"
    //           ? "greenLabel"
    //           : item.orderStatus == "cancelled"
    //           ? "redLabel"
    //           : ""
    //       } rounded-pill px-2  m-0 text-capitalize py-1 text-center`}
    //     >
    //       {findLabelOfStatus(item.orderStatus)}
    //     </p>
    //   ),
    // },
    {
      head: "Action",
      accessor: "Action",
            component: (item, key, arr) => (
                <TableActions  viewHandler={() => openModal(item)} />
      ),
    }
  );
  const closeModal = () => {
  setSelectedReport(null);
  setShowModal(false);
};


  return (
    <>
    <Modal show={showModal} onHide={closeModal} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{selectedReport?.noticeId?.title}</Modal.Title>
      </Modal.Header>
    
      <Modal.Body>
        {selectedReport?.noticeId?.description ? (
          <div
            dangerouslySetInnerHTML={{
              __html: selectedReport.noticeId.description
            }}
          />
        ) : (
          <p>No description available</p>
        )}
      </Modal.Body>
    
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
      <secstion className="help position-relative py-3">
        <Container className="py-3">
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Report Management
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    // statusFilterOptionArr={filterOptions}
                  />
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        type="button"
                        onClick={() =>
                          exportCsvHandler("reported", setExportLoader,body)
                        }
                      >
                        {exportLoader ? <ButtonLoader /> : "Export CSV"}
                      </Button>
                    </li>
                    {/* <li className="">
                                      <Link
                                        to="/manage-user/add"
                                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                                      >
                                        Add New
                                      </Link>
                                    </li> */}
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                body={body}
                pageChangeHandler={paginationHandler}
                setBody={setBody}
                total={total}
              />
            </Col>
          </Row>
        </Container>
      </secstion>
    </>
  );
};

export default Reported;
